exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-section{margin-bottom:50px}@media screen and (max-width:992px){.title-section{margin-bottom:30px}}.section-revolution-travels{padding:30px 0 60px}@media screen and (max-width:1240px){.section-revolution-travels{padding:40px 20px}}.box-content{gap:105px}@media screen and (max-width:992px){.box-content{display:flex;flex-direction:column-reverse;gap:0}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};